// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__2q7yV","info":"Note_info__WQ5qW","note":"Note_note__1Eopv","actions":"Note_actions__3DK2g"};